<template>
  <!-- 配送方式弹窗 -->
  <van-popup v-model="popShow" round position="bottom" :style="{ height: '100%' }">
    <h2>配送方式</h2>
    <van-radio-group v-model="distributionType">
      <van-cell-group>
        <van-cell title="中国邮政快递包裹" clickable @click="distributionType = 1">
          <template #right-icon>
            <van-radio :name="1" />
          </template>
        </van-cell>
        <van-cell title="自取" clickable @click="chooseGetWay">
          <template #right-icon>
            <van-radio :name="2" :disabled="provinceName !== '北京市'" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>
    <!-- 确认选择 -->
    <van-button type="primary" block @click="confireChooseDistrubution">确认</van-button>
  </van-popup>
</template>

<script>
  export default {
    model: {
      event: 'change',
      prop: 'show'
    },
    props: ['show', 'info'],
    data() {
      return {
        active: 2,
        formData: {},
        distributionType: 1,
        popShow: false,
        provinceName: '' // 升级地址
      }
    },
    watch: {
      show(newValue) {
        this.popShow = newValue
        if (newValue) {
          // 保存全局的省级地址
          let { provinceName } = JSON.parse(window.localStorage.getItem('addressInfo')) || {}
          this.provinceName = provinceName
          this.distributionType = this.info && this.info.type
        }
      }
    },
    methods: {
      /**
       * 自取
       */
      chooseGetWay() {
        if (this.provinceName !== '北京市') {
          return
        }
        this.distributionType = 2
      },
      /**
       * todo 选择自取后，二次确认弹窗
       */
      confireChooseDistrubution() {
        const beforeClose = (action, done) => {
          if (action === 'confirm') {
            this.$emit('change', false)
            this.$emit('confirmInfo', this.distributionType)
          }
          done()
        }
        if (this.distributionType === 2) {
          this.$dialog.confirm({
            title: '',
            message: '您的配送方式为自取，自取地址请联系客服电话010-65368820',
            beforeClose
          })
        } else {
          this.$emit('change', false)
          this.$emit('confirmInfo', this.distributionType)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .van-popup {
    background: #eee;
    .van-button {
      margin-top: 3vh;
    }
  }
</style>
